import { useIntl } from "react-intl";

import { CompassLogo } from "@atlaskit/logo";
import UFOSegment from "@atlaskit/react-ufo/segment";
import { Editions, ProductKeys } from "@atlassiansox/asc-stargate";

import { useCrossFlowFrontendTouchpoint } from "@/components/cross-flow/touchpoint";
import { useLocalizedHref } from "@/libraries/web-framework";
import { LogoV3 } from "@/libraries/wpl/foundations/src";
import { ProductPageSubNav } from "@/patterns/global-nav/src";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

const CompassLogoComponent = () => {
    const gwp7518NavIconUpdates = checkFeatureFlagGate(
        featureFlags.gwp7518NavIconUpdates
    );

    return gwp7518NavIconUpdates ? (
        <LogoV3 brand="compass" type="logo" appearance="brand" />
    ) : (
        <CompassLogo appearance="brand" />
    );
};

export const CompassNav = () => {
    const intl = useIntl();

    const signupLink = useLocalizedHref(
        "/try/cloud/signup?bundle=compass&edition=free"
    );
    const { openCrossFlow } = useCrossFlowFrontendTouchpoint({
        productKey: ProductKeys.COMPASS,
        edition: Editions.FREE,
        redirectUrl: signupLink
    });
    const pricingHref = useLocalizedHref("/software/compass/pricing");
    return (
        <UFOSegment name="confluence-pt-cfind-1234-CompassNav">
            <ProductPageSubNav
                productLogoUrl="/software/compass"
                productLogo={<CompassLogoComponent />}
                productLogoAriaLabel={intl.formatMessage({
                    id: "CompassPageTemplate.navbar.compass-logo",
                    defaultMessage: "Compass logo"
                })}
                mobileCtaText={intl.formatMessage({
                    id: "CompassPageTemplate.navbar.getitfree",
                    defaultMessage: "Get it Free"
                })}
                navigationTrynowCtaText={intl.formatMessage({
                    id: "CompassPageTemplate.navbar.getitfree",
                    defaultMessage: "Get it Free"
                })}
                mobileCtaUrl={signupLink}
                mobileCtaOnClick={openCrossFlow}
                mobileLogo={<CompassLogoComponent />}
                productPageNavLinks={[
                    {
                        globalLinksKey: "features",
                        linkText: intl.formatMessage({
                            id: "CompassPageTemplate.navbar.features",
                            defaultMessage: "Features"
                        }),
                        hasSubnav: false,
                        productKey: "compass",
                        href: useLocalizedHref("/software/compass/features")
                    },
                    {
                        globalLinksKey: "pricing",
                        linkText: intl.formatMessage({
                            id: "CompassPageTemplate.navbar.pricing",
                            defaultMessage: "Pricing"
                        }),
                        hasSubnav: false,
                        productKey: "compass",
                        href: pricingHref
                    }
                ]}
                navigationTrynowCtaUrl={signupLink}
                navigationTrynowCtaOnClick={openCrossFlow}
                mobileLinksSections={[
                    {
                        mobileLinkKey: "mobile-compass",
                        mobileLinksProps: [
                            {
                                globalLinksKey: "features",
                                linkText: intl.formatMessage({
                                    id: "CompassPageTemplate.navbar.features",
                                    defaultMessage: "Features"
                                }),
                                hasSubnav: false,
                                productKey: "compass",
                                href: useLocalizedHref(
                                    "/software/compass/features"
                                )
                            },
                            {
                                globalLinksKey: "pricing",
                                linkText: intl.formatMessage({
                                    id: "CompassPageTemplate.navbar.pricing",
                                    defaultMessage: "Pricing"
                                }),
                                hasSubnav: false,
                                productKey: "compass",
                                href: pricingHref
                            }
                        ]
                    }
                ]}
            />
        </UFOSegment>
    );
};
